var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin-for-nav"},[_c('page',{attrs:{"category":_vm.category},scopedSlots:_vm._u([{key:"page",fn:function(pageProps){return [_c('affixed-section',{attrs:{"section":pageProps.section,"index":pageProps.index},scopedSlots:_vm._u([{key:"default",fn:function(sectProps){return _c(sectProps.component,{tag:"component",attrs:{"section":sectProps.section,"side":sectProps.side}})}}])})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-799304f9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Project3.vue
// module id = 360
// module chunks = 0